import styled from 'styled-components';

import { RewardLock } from '../../reward-lock';

export const LockIconContainer = styled.div`
  position: relative;
  inset-inline-end: 45px;
`;

export const StyledRewardLock = styled(RewardLock)`
  transform: scale(0.5);
  > div {
    background-color: ${Styles.color.black};
    ::before,
    ::after {
      border-color: ${Styles.color.black};
    }
    ::after {
      background-color: inherit;
    }
  }
`;
